/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import { green } from '@ant-design/colors';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  DollarOutlined,
  EditOutlined,
  LoadingOutlined,
  MinusCircleOutlined,
  SettingOutlined
} from '@ant-design/icons';
import { Grid, Popconfirm, Space, Tag, Tooltip, Typography } from 'antd';
import React, {
  Fragment,
  useEffect,
  useLayoutEffect,
  useRef,
  useState
} from 'react';
import styled from 'styled-components';
import EditableInputField from '../../components/EditableInputField';
import InputRight from '../../components/InputRight';
import SelectableListDrawer from '../../components/SelectableListDrawer';
import SubcoberturasRadioListPopover from '../../components/SubcoberturasRadioListPopover';
import { CONFIG } from '../../constants';
import {
  getCoberturaLabel,
  getCostoLabel
} from '../../functions/opcionesSubcobertura';
import addScrollShadows from '../../scroll-util';
import {
  getCoberturasLandingTable,
  getDescripcionOpcion,
  getTable,
  getTableOpcionesPago,
  hexToRgb
} from '../../utils';
import { formatoMonedaGenerico } from '../../utils/converters';

const { useBreakpoint } = Grid;

const backgroundColor = '#fafafa';
const border = '#f0f0f0';
const borderSolid = '#f0f0f0';

const Container = styled.div`
  border: ${(props) =>
    props.selected
      ? `1px solid ${CONFIG.COLOR_PRIMARY}`
      : `1px solid ${borderSolid}`};
  border-radius: 6px;
  overflow: auto;
  ${(props) =>
    !props.isMobile && props.hover
      ? `&:hover {
    border: 1px solid ${CONFIG.COLOR_PRIMARY};
  }`
      : ``};
`;

const getOptions = (monedaParam) => {
  if (!monedaParam) {
    return {};
  }
  if (monedaParam.codigo === 'gs') {
    return {
      decimalsLimit: 0,
      decimalSeparator: ',',
      groupSeparator: '.',
      simbolo: `${monedaParam.simbolo} `,
      posicionSimbolo: 'i'
    };
  }
  if (monedaParam.codigo === 'usd') {
    return {
      decimalsLimit: 2,
      decimalSeparator: '.',
      groupSeparator: ',',
      simbolo: `${monedaParam.simbolo} `,
      posicionSimbolo: 'i'
    };
  }
  return {};
};

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const InputIcon = ({ incluye, onClick, loading, edit, value }) => {
  if (loading) {
    return <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />;
  }
  if (edit) {
    return Number.isNaN(Number(value)) ? (
      <Tooltip title="Click para Editar">
        <EditOutlined onClick={onClick} style={{ color: 'rgba(0,0,0,.45)' }} />
      </Tooltip>
    ) : (
      <Tooltip title="Click para cancelar">
        <CloseCircleOutlined
          onClick={onClick}
          style={{ color: 'rgba(0,0,0,.45)' }}
        />
      </Tooltip>
    );
  }
  const iconProps = {
    onClick,
    style: { color: 'rgba(0,0,0,.45)' }
  };
  const icon = incluye ? (
    <CheckCircleOutlined {...iconProps} />
  ) : (
    <MinusCircleOutlined {...iconProps} />
  );
  return (
    <Tooltip title={`Click para ${incluye ? 'Excluir' : 'Incluir'}`}>
      {icon}
    </Tooltip>
  );
};

const InputIconEdit = ({ onClick, active, loading }) => {
  if (loading) {
    return <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />;
  }
  return (
    <Tooltip title="Editar Franquicia">
      <DollarOutlined
        onClick={onClick}
        style={{ color: active ? green.primary : 'rgba(0,0,0,.45)' }}
      />
    </Tooltip>
  );
};

const columnsOpcionesCobertura = [
  {
    title: 'Tipo',
    dataIndex: ['opcion'],
    key: ['opcion'],
    render: (text, record) => {
      return getDescripcionOpcion(record.opcion);
    }
  },
  {
    title: 'Cobertura',
    render: (text, record) => {
      const coberturaObj = getCoberturaLabel(record);
      return coberturaObj ? coberturaObj.label : '';
    }
  },
  {
    title: 'Costo',
    render: (text, record) => {
      return getCostoLabel(record);
    }
  },
  {
    title: 'Costo Mínimo',
    render: (text, record) => {
      return (
        record.costo_min &&
        formatoMonedaGenerico(record.moneda, record.costo_min)
      );
    }
  },
  {
    title: 'Costo Máximo',
    render: (text, record) => {
      return (
        record.costo_max &&
        formatoMonedaGenerico(record.moneda, record.costo_max)
      );
    }
  }
];

const InputIconEditCoberturaMinMax = ({ onClick, loading }) => {
  if (loading) {
    return <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />;
  }
  return (
    <Tooltip title="Editar monto Máximo y Mínimo">
      <SettingOutlined onClick={onClick} style={{ color: 'rgba(0,0,0,.45)' }} />
    </Tooltip>
  );
};

const PlanEditor = ({
  onChangePlan,
  canChangeTitle,
  onChangePlanTitle,
  onDeletePlan,
  onEditPlan,
  onEditPlanConfig,
  onEditPlanFranquicia,
  onEditPlanSubcoberturas,
  onDeleteCobertura,
  defaultSelected,
  planes,
  selected,
  hover,
  isLanding,
  coberturasLanding,
  opcionesDePago,
  planLoading,
  onEditPlanCoberturaItem,
  onEditPlanCoberturaMinMaxItem,
  producto,
  moneda,
  amedida,
  subcoberturasParaExcluir,
  controlFranquicias,
  puedeEditar,
  comisionAseguradora
}) => {
  const planSelected = defaultSelected || 0;
  const [hoveredIndex, setHoveredIndex] = useState();
  const options = getOptions(moneda);

  const canChangeTitlePlan = (idPlan) => {
    if (canChangeTitle) {
      return canChangeTitle.includes(idPlan);
    }
    return true;
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const planesFiltrado = moneda
    ? planes
        .sort((a, b) => a.orden - b.orden)
        .filter(
          (plan) =>
            plan.moneda.codigo === moneda.codigo &&
            plan.comisionAseguradora?.id === comisionAseguradora?.id
        )
    : [];

  const coberturasLandingFiltradas =
    isLanding && !moneda
      ? coberturasLanding &&
        coberturasLanding.filter(
          (cobertura) => cobertura.moneda.codigo === 'gs'
        )
      : coberturasLanding &&
        coberturasLanding.filter(
          (cobertura) => cobertura.id_moneda === moneda.id
        );
  const data = !isLanding
    ? getTable(
        planesFiltrado,
        null,
        null,
        producto,
        null,
        true,
        undefined,
        false,
        moneda,
        subcoberturasParaExcluir,
        controlFranquicias
      ).filter((e) => !e.exclusion || (e.incluye && e.franquicia_general))
    : getCoberturasLandingTable({
        coberturasLanding: coberturasLandingFiltradas
      });
  const sinCoberturas = data.length === 1;
  const screens = useBreakpoint();
  const tableRef = useRef({});
  const nomberOfPlans = usePrevious(planesFiltrado.length);
  const widthMobile = '100px';
  const styles = {
    fontSize: screens.md === false ? 11 : 14,
    paddingLeft: screens.md === false ? 4 : 8,
    paddingRight: screens.md === false ? 4 : 8,
    paddingTop: screens.md === false ? 2 : 4,
    paddingBottom: screens.md === false ? 2 : 4
  };
  const width =
    screens && screens.md === false
      ? { minWidth: widthMobile, maxWidth: widthMobile }
      : { minWidth: '250px', maxWidth: '500px' };

  const Header = styled.div`
    font-size: ${() => styles.fontSize};
    font-weight: bold;
    min-width: ${() => width.minWidth || '250px'};
    max-width: ${() => width.maxWidth || '500px'};
    display: inline-block;
    float: left;
    clear: both;
    width: max-content;
  `;

  const Detalle = styled.div`
    font-size: ${() => styles.fontSize};
    min-width: ${() => width.minWidth || '250px'};
    max-width: ${() => width.maxWidth || '500px'};
    display: inline-block;
    float: left;
    clear: both;
    width: max-content;
  `;

  const GroupHeader = styled.div`
    font-weight: bold;
    min-width: ${() => width.minWidth || '250px'};
    max-width: ${() => width.maxWidth || '500px'};
    display: inline-block;
    float: left;
    clear: both;
    width: max-content;
  `;

  const Footer = styled.div`
    font-size: ${() => styles.fontSize};
    min-width: ${() => width.minWidth || '250px'};
    max-width: ${() => width.maxWidth || '500px'};
    display: inline-block;
    float: left;
    clear: both;
    width: max-content;
  `;

  const planTitleStyle = (dataSource, rowIndex, item) => {
    const cantFooters = dataSource.filter((element) => element.footer).length;

    const style = {
      fontSize: styles.fontSize,
      paddingLeft: styles.paddingLeft,
      paddingRight: styles.paddingRight,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
      backgroundColor: 'white'
    };
    if (rowIndex === 0) {
      return {
        ...style,
        backgroundColor,
        borderBottom: `1px solid ${border}`,
        borderRight: `1px solid ${border}`
      };
    }

    if (rowIndex > 0 && rowIndex < data.length - 1 && !item.footer) {
      if (rowIndex < data.length - cantFooters - 1) {
        style.borderBottom = `1px solid ${border}`;
      }
      return {
        ...style,
        fontWeight: 'normal',
        borderRight: `1px solid ${border}`
      };
    }
    if (rowIndex > data.length - cantFooters - 1 || item.footer) {
      return {
        ...style,
        borderTop: `1px solid ${border}`,
        borderRight: `1px solid ${border}`,
        backgroundColor
      };
    }
    return {
      ...style,
      fontWeight: 'normal',
      borderRight: `1px solid ${border}`
    };
  };

  const planStyle = (dataSource, columnIndex, rowIndex) => {
    const cantFooters = dataSource.filter((element) => element.footer).length;
    const style = {
      fontSize: styles.fontSize,
      paddingLeft: styles.paddingLeft,
      paddingRight: styles.paddingRight,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
      textAlign: 'right',
      cursor: hover ? 'pointer' : 'default',
      whiteSpace: 'nowrap',
      justifyContent: 'flex-end',
      alignItems: 'center',
      maxWidth: 300
    };
    if (rowIndex === 0 || rowIndex > dataSource.length - cantFooters - 1) {
      style.backgroundColor = backgroundColor;
    }

    if (hoveredIndex < 0) {
      return style;
    }

    if (columnIndex === hoveredIndex) {
      style.color = 'white';
      style.backgroundColor = `rgb(${hexToRgb(CONFIG.COLOR_PRIMARY)}, 0.75)`;
    }

    if (columnIndex === planSelected && selected) {
      style.color = 'white';
      style.backgroundColor = CONFIG.COLOR_PRIMARY;
    }

    if (rowIndex < dataSource.length - cantFooters - 1) {
      style.borderBottom = `1px solid ${border}`;
    }

    if (rowIndex === 0) {
      style.fontWeight = 'bold';
    }

    if (rowIndex > dataSource.length - cantFooters - 1) {
      style.fontWeight = 'bold';
      style.borderTop = `1px solid ${border}`;
    }
    if (
      dataSource[rowIndex].franquicia ||
      dataSource[rowIndex].franquicia_general
    ) {
      style.whiteSpace = 'normal';
    }
    return style;
  };

  const InputIconEditFranquicia = ({ onClick, loading }) => {
    if (loading) {
      return <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />;
    }
    return (
      <Tooltip title="Editar Franquicia">
        <EditOutlined onClick={onClick} style={{ color: 'rgba(0,0,0,.45)' }} />
      </Tooltip>
    );
  };

  const OpcionesDePago = () => {
    const dataOpcionesPago = getTableOpcionesPago(
      planesFiltrado,
      undefined,
      opcionesDePago,
      moneda
    );
    return (
      <tbody style={{ borderBottom: `1px solid ${border}` }}>
        {dataOpcionesPago.map((item, rowIndex) => (
          <tr key={rowIndex}>
            {rowIndex === 0 && (
              <td
                style={planTitleStyle(dataOpcionesPago, rowIndex, item)}
                className="sticky-header"
              >
                <Header>{item.detalle}</Header>
              </td>
            )}

            {rowIndex > 0 && (
              <td
                style={planTitleStyle(dataOpcionesPago, rowIndex, item)}
                className="sticky-column"
              >
                <Detalle>{item.detalle}</Detalle>
              </td>
            )}

            {item.sumas.map((suma, columnIndex) => {
              const canChange =
                onChangePlanTitle &&
                canChangeTitlePlan(item.items?.[columnIndex].id_plan);
              return (
                <td
                  key={columnIndex}
                  style={planStyle(dataOpcionesPago, columnIndex, rowIndex)}
                  onMouseOver={() => {
                    if (hover) {
                      setHoveredIndex(columnIndex);
                    }
                  }}
                  onMouseLeave={() => {
                    if (hover) {
                      setHoveredIndex(undefined);
                    }
                  }}
                >
                  <Space>
                    {rowIndex === 0 && (
                      <span>{item.items?.[columnIndex].id_plan}</span>
                    )}
                    {rowIndex === 0 && canChange && (
                      <InputRight
                        tabIndex="-1"
                        onBlur={(event) =>
                          onChangePlanTitle(
                            event,
                            item.items[columnIndex].id_plan
                          )
                        }
                        defaultValue={suma}
                        placeholder={`Plan ${columnIndex + 1}`}
                        suffix={
                          <EditOutlined
                            style={{
                              color: CONFIG.COLOR_PRIMARY
                            }}
                          />
                        }
                      />
                    )}
                    {rowIndex === 0 &&
                      !canChange &&
                      (suma || `Plan ${columnIndex + 1}`)}
                    {rowIndex === 0 && onEditPlan && (
                      <>
                        {planLoading[item.items[columnIndex].id_plan] ? (
                          <LoadingOutlined
                            style={{
                              color: 'rgba(0,0,0,.45)'
                            }}
                          />
                        ) : (
                          <>
                            {/* condicion que indica si va a aparecer o no el engranaje */}
                            {puedeEditar && (
                              <SettingOutlined
                                disabled={
                                  planLoading[item.items[columnIndex].id_plan]
                                }
                                onClick={() =>
                                  onEditPlan(item.items[columnIndex].id_plan)
                                }
                                style={{
                                  color: CONFIG.COLOR_PRIMARY
                                }}
                              />
                            )}
                          </>
                        )}
                        {planLoading[item.items[columnIndex].id_plan] ? (
                          <LoadingOutlined
                            style={{
                              color: 'rgba(0,0,0,.45)'
                            }}
                          />
                        ) : (
                          onEditPlanFranquicia && (
                            <DollarOutlined
                              disabled={
                                planLoading[item.items[columnIndex].id_plan]
                              }
                              onClick={() =>
                                onEditPlanFranquicia(
                                  item.items[columnIndex].id_plan
                                )
                              }
                              style={{
                                color: CONFIG.COLOR_PRIMARY
                              }}
                            />
                          )
                        )}
                        {onEditPlanConfig &&
                          onEditPlanConfig(item.items[columnIndex].id_plan)}
                        {onDeletePlan && (
                          <Popconfirm
                            disabled={
                              planLoading[item.items[columnIndex].id_plan]
                            }
                            title="¿Está seguro? Se eliminará toda la información del plan"
                            onConfirm={() => confirmDeletePlan(columnIndex)}
                            okText="Si"
                            cancelText="No"
                          >
                            <DeleteOutlined
                              style={{ color: 'rgba(0,0,0,.45)' }}
                            />
                          </Popconfirm>
                        )}
                      </>
                    )}
                    {rowIndex !== 0 && (
                      <span
                        style={{
                          fontSize: rowIndex === 0 ? 14 : 'inherit'
                        }}
                      >
                        {suma}
                      </span>
                    )}
                  </Space>
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    );
  };

  const getLink = (idCobertura) => {
    return `/cobertura/search/subcobertura?idCobertura=${idCobertura}`;
  };

  const getEndPointPlanSubcobOpciones = (idPlan, idCobertura) => {
    return `/plansubcoberturaopcion/search/${idPlan}/${idCobertura}`;
  };

  const confirmDeletePlan = (index) => {
    onDeletePlan(index);
    addScrollShadows();
  };

  const confirmDeleteCobertura = (id) => {
    onDeleteCobertura(id);
    addScrollShadows();
  };

  const onClickEdit = (suma, item, columnIndex, opcionSubcobertura) => {
    let valueObj;
    if (onChangePlan) {
      if (opcionSubcobertura === 'valor_capital') {
        // Si es un valor numerico valido devuelve cero, si no devuelve -3
        // El valor -3 equivale al 100% de la cobertura.
        const valueColumn = !Number.isNaN(Number(suma)) ? '0' : -3;
        valueObj = {
          target: {
            value: valueColumn
          }
        };
      } else if (
        opcionSubcobertura === 'suma_tabla_ovp' ||
        opcionSubcobertura === 'suma_tabla_rc'
      ) {
        const valueColumn = !Number.isNaN(Number(suma)) ? '0' : -3;
        valueObj = {
          target: {
            value: valueColumn
          }
        };
      }

      onChangePlan(valueObj, item.items[columnIndex].id, columnIndex);
    }
  };
  const scrollEnd = () => {
    tableRef.current.scrollTo({
      top: 0,
      left: tableRef.current.scrollWidth,
      behavior: 'smooth'
    });
  };

  useLayoutEffect(() => {
    setTimeout(() => addScrollShadows(), 500);
  }, [screens]);

  useEffect(() => {
    if (planesFiltrado.length > nomberOfPlans) {
      scrollEnd();
    }
  }, [planesFiltrado, nomberOfPlans]);

  return (
    <>
      <Container
        selected={selected}
        style={{ margin: 'auto', width: '100%', display: 'grid' }}
        hover={hover}
        className="table-wrapper"
      >
        <div className="table-shadow shadow-left" />
        <div className="table-inner-wrapper" ref={tableRef}>
          <table
            style={{
              textAlign: 'start',
              width: '100%',
              borderRadius: 6
            }}
            className="table"
          >
            {opcionesDePago && (
              <>
                <OpcionesDePago />
                {/* {data && data.length > 1 && (
                    <tbody>
                      <tr>
                        <td
                          style={{
                            // ...planTitleStyle(data, 1, data[1]),
                            height: 16,
                            borderTop: planTitleStyle(data, 1, data[1])
                              .borderBottom,
                            borderBottom: planTitleStyle(data, 1, data[1])
                              .borderBottom,
                            borderRight: '1px solid white'
                          }}
                          className="sticky-header"
                        />
                        {data[1].sumas.map((_, columnIndex) => (
                          <td
                            key={`${columnIndex}colgrupo`}
                            onMouseOver={() => {
                              if (hover) {
                                setHoveredIndex(columnIndex);
                              }
                            }}
                            onMouseLeave={() => {
                              if (hover) {
                                setHoveredIndex(undefined);
                              }
                            }}
                          />
                        ))}
                      </tr>
                    </tbody>
                  )} */}
              </>
            )}
            <tbody>
              {data.map((item, rowIndex) => (
                <Fragment key={rowIndex}>
                  {item.full ? (
                    <Fragment key={rowIndex}>
                      {item.detalle && item.detalle.trim() ? (
                        <tr key={rowIndex}>
                          <td
                            // colSpan={item.sumas.length + 1}
                            style={{
                              ...planTitleStyle(data, rowIndex, item)
                            }}
                            className="sticky-header"
                          >
                            <GroupHeader>{item.detalle}</GroupHeader>
                          </td>
                          {item.sumas.map((_, columnIndex) => (
                            <td
                              key={`${columnIndex}colgrupo`}
                              onMouseOver={() => {
                                if (hover) {
                                  setHoveredIndex(columnIndex);
                                }
                              }}
                              onMouseLeave={() => {
                                if (hover) {
                                  setHoveredIndex(undefined);
                                }
                              }}
                              onClick={() => {
                                // if (onChange) {
                                //   onChange(columnIndex);
                                // }
                              }}
                            />
                          ))}
                        </tr>
                      ) : null}
                    </Fragment>
                  ) : (
                    <tr key={rowIndex}>
                      {rowIndex === 0 && (
                        <td
                          style={planTitleStyle(data, rowIndex, item)}
                          className="sticky-header"
                        >
                          <Header>{item.detalle} </Header>
                        </td>
                      )}
                      {rowIndex > 0 &&
                        (isLanding || rowIndex < data.length) &&
                        !item.footer && (
                          <td
                            style={planTitleStyle(data, rowIndex, item)}
                            className="sticky-column"
                          >
                            <div style={{ display: 'flex' }}>
                              {item.franquicia || item.franquicia_general ? (
                                item.detalle
                              ) : (
                                <Space>
                                  <Popconfirm
                                    title="¿Está seguro? Se eliminará toda la información de la cobertura"
                                    onConfirm={() =>
                                      confirmDeleteCobertura(item.id)
                                    }
                                    okText="Si"
                                    cancelText="No"
                                  >
                                    <DeleteOutlined
                                      style={{
                                        color: 'rgba(0,0,0,.45)',
                                        alignSelf: 'center'
                                      }}
                                    />
                                  </Popconfirm>
                                  <Detalle>{item.detalle}</Detalle>
                                </Space>
                              )}
                            </div>
                          </td>
                        )}

                      {!isLanding && item.footer && (
                        <td
                          style={planTitleStyle(data, rowIndex, item)}
                          className="sticky-header"
                        >
                          <Footer>{item.detalle}</Footer>
                        </td>
                      )}

                      {item.sumas.map((suma, columnIndex) => {
                        const canChange =
                          onChangePlanTitle &&
                          canChangeTitlePlan(item.items?.[columnIndex].id_plan);
                        return (
                          <td
                            key={columnIndex}
                            style={planStyle(data, columnIndex, rowIndex)}
                            onMouseOver={() => {
                              if (hover) {
                                setHoveredIndex(columnIndex);
                              }
                            }}
                            onMouseLeave={() => {
                              if (hover) {
                                setHoveredIndex(undefined);
                              }
                            }}
                          >
                            {rowIndex === 0 && (
                              <>
                                <Space>
                                  {canChange && !opcionesDePago && (
                                    <InputRight
                                      tabIndex="-1"
                                      onChange={(event) =>
                                        onChangePlanTitle(
                                          event,
                                          item.items[columnIndex].id_plan
                                        )
                                      }
                                      value={suma}
                                      placeholder={`Plan ${columnIndex + 1}`}
                                      suffix={
                                        amedida ? (
                                          ''
                                        ) : (
                                          <EditOutlined
                                            style={{
                                              color: CONFIG.COLOR_PRIMARY
                                            }}
                                          />
                                        )
                                      }
                                    />
                                  )}
                                  {!canChange &&
                                    !opcionesDePago &&
                                    (suma || `Plan ${columnIndex + 1}`)}
                                  {item?.items?.[columnIndex]?.estado ===
                                    'BORRADOR' && (
                                    <Tag color="yellow">Borrador</Tag>
                                  )}
                                </Space>
                              </>
                            )}

                            {rowIndex !== 0 && item.items && (
                              <>
                                {item.franquicia ? (
                                  item.sumas[columnIndex] !== 'No Aplica' ? (
                                    <Space>
                                      <span>{suma}</span>
                                      {onEditPlanCoberturaItem && (
                                        <InputIconEditFranquicia
                                          loading={
                                            planLoading &&
                                            planLoading[
                                              item.items[columnIndex].id_plan
                                            ]
                                          }
                                          onClick={() =>
                                            onEditPlanCoberturaItem(
                                              item.items[columnIndex],
                                              item.items[columnIndex].id,
                                              columnIndex
                                            )
                                          }
                                        />
                                      )}
                                    </Space>
                                  ) : (
                                    'No Aplica'
                                  )
                                ) : (
                                  <>
                                    {isLanding && item.items[columnIndex] && (
                                      <EditableInputField
                                        editable={
                                          puedeEditar ||
                                          item.items[columnIndex].editable
                                        }
                                        tabIndex="0"
                                        options={options}
                                        value={suma}
                                        moneda={moneda}
                                      />
                                    )}

                                    {!isLanding &&
                                    item.items[columnIndex].subcobertura ? (
                                      <EditableInputField
                                        editable={
                                          puedeEditar ||
                                          item.items[columnIndex].editable
                                        }
                                        tabIndex="0"
                                        onChange={(event) => {
                                          if (onChangePlan) {
                                            if (
                                              [
                                                'suma_tabla_ovp',
                                                'suma_tabla_rc'
                                              ].includes(
                                                item.items[columnIndex]
                                                  .subcobertura.opcion
                                              )
                                            ) {
                                              onChangePlan(
                                                event,
                                                item.items[columnIndex].id,
                                                columnIndex
                                              );
                                              // onChangePlan(
                                              //   Number(event) === 0
                                              //     ? -1
                                              //     : event,
                                              //   item.items[columnIndex].id,
                                              //   columnIndex
                                              // );
                                            } else {
                                              onChangePlan(
                                                event,
                                                item.items[columnIndex].id,
                                                columnIndex
                                              );
                                            }
                                          }
                                        }}
                                        options={options}
                                        value={suma}
                                        moneda={moneda}
                                        readOnly={
                                          !onChangePlan ||
                                          (planLoading &&
                                            planLoading[
                                              item.items[columnIndex].id_plan
                                            ]) ||
                                          (item.items[columnIndex].subcobertura
                                            .opcion !== 'valor_capital' &&
                                            item.items[columnIndex].subcobertura
                                              .opcion !== 'suma_tabla_ovp' &&
                                            item.items[columnIndex].subcobertura
                                              .opcion !== 'suma_tabla_rc')
                                        }
                                        style={{ textAlign: 'end' }}
                                        suffix={
                                          !isLanding && (
                                            <Space>
                                              {[
                                                'valor_capital',
                                                'suma_tabla_ovp',
                                                'suma_tabla_rc'
                                              ].includes(
                                                item.items[columnIndex]
                                                  .subcobertura.opcion
                                              ) ? (
                                                <InputIcon
                                                  edit
                                                  value={suma}
                                                  loading={
                                                    planLoading &&
                                                    planLoading[
                                                      item.items[columnIndex]
                                                        .id_plan
                                                    ]
                                                  }
                                                  onClick={() => {
                                                    const opcionSubcobertura =
                                                      item.items[columnIndex]
                                                        .subcobertura.opcion;
                                                    onClickEdit(
                                                      suma,
                                                      item,
                                                      columnIndex,
                                                      opcionSubcobertura
                                                    );
                                                  }}
                                                />
                                              ) : (
                                                <div style={{ width: 14 }} />
                                              )}
                                              {amedida ? (
                                                <SubcoberturasRadioListPopover
                                                  urlFetchList={getEndPointPlanSubcobOpciones(
                                                    item.items[columnIndex]
                                                      .id_plan,
                                                    item.items[columnIndex]
                                                      .subcobertura.cobertura
                                                      ?.id
                                                  )}
                                                  checked={
                                                    item.items[columnIndex]
                                                      .subcobertura
                                                  }
                                                  handleChange={(checked) => {
                                                    const newSubcobertura = checked;
                                                    onEditPlanSubcoberturas(
                                                      item.items[columnIndex]
                                                        .id_plan,
                                                      newSubcobertura.id_cobertura,
                                                      newSubcobertura
                                                    );
                                                  }}
                                                  subcoberturasParaExcluir={
                                                    subcoberturasParaExcluir
                                                  }
                                                  plan={planesFiltrado.find(
                                                    (e) =>
                                                      e.id ===
                                                      item.items[columnIndex]
                                                        .id_plan
                                                  )}
                                                />
                                              ) : (
                                                <SelectableListDrawer
                                                  isMultiple
                                                  url={getLink(
                                                    item.items[columnIndex]
                                                      .subcobertura.cobertura
                                                      .id,
                                                    item.items[columnIndex]
                                                      .subcobertura.cobertura
                                                      .id_aseguradora_producto
                                                  )}
                                                  columnsData={
                                                    columnsOpcionesCobertura
                                                  }
                                                  listChecked={
                                                    planes.find(
                                                      (e) =>
                                                        e.id ===
                                                        item.items[columnIndex]
                                                          .id_plan
                                                    )?.planSubcoberturaOpcion
                                                  }
                                                  porDefecto={
                                                    item.items[columnIndex]
                                                      .subcobertura
                                                  }
                                                  title={
                                                    item.items[columnIndex]
                                                      .subcobertura.cobertura
                                                      .descripcion
                                                  }
                                                  placement={
                                                    screens &&
                                                    screens.md === false
                                                      ? 'bottom'
                                                      : 'right'
                                                  }
                                                  handleChange={(
                                                    seleccionadas,
                                                    porDefecto
                                                  ) => {
                                                    onEditPlanSubcoberturas(
                                                      seleccionadas,
                                                      porDefecto,
                                                      item.items[columnIndex]
                                                        .id_plan,
                                                      true
                                                    );
                                                  }}
                                                />
                                              )}

                                              <InputIcon
                                                loading={
                                                  planLoading &&
                                                  planLoading[
                                                    item.items[columnIndex]
                                                      .id_plan
                                                  ]
                                                }
                                                onClick={() => {
                                                  if (onChangePlan) {
                                                    if (
                                                      [
                                                        'suma_tabla_ovp',
                                                        'suma_tabla_rc'
                                                      ].includes(
                                                        item.items[columnIndex]
                                                          .subcobertura.opcion
                                                      )
                                                    ) {
                                                      onChangePlan(
                                                        {
                                                          target: {
                                                            value:
                                                              suma === 'Excluye'
                                                                ? -3
                                                                : -1
                                                          }
                                                        },
                                                        item.items[columnIndex]
                                                          .id,
                                                        columnIndex
                                                      );
                                                    } else {
                                                      onChangePlan(
                                                        {
                                                          target: {
                                                            value:
                                                              suma === 'Excluye'
                                                                ? 0
                                                                : -1
                                                          }
                                                        },
                                                        item.items[columnIndex]
                                                          .id,
                                                        columnIndex
                                                      );
                                                    }
                                                  }
                                                }}
                                                incluye={suma !== 'Excluye'}
                                              />
                                              {!amedida && (
                                                <>
                                                  <InputIconEdit
                                                    loading={
                                                      planLoading &&
                                                      planLoading[
                                                        item.items[columnIndex]
                                                          .id_plan
                                                      ]
                                                    }
                                                    onClick={() =>
                                                      onEditPlanCoberturaItem(
                                                        item.items[columnIndex],
                                                        item.items[columnIndex]
                                                          .id,
                                                        columnIndex
                                                      )
                                                    }
                                                    active={
                                                      item.items[columnIndex]
                                                        .franquicia_opcion
                                                    }
                                                  />

                                                  <div
                                                    style={{
                                                      visibility: [
                                                        'suma_tabla_ovp',
                                                        'suma_tabla_rc',
                                                        'valor_capital'
                                                      ].includes(
                                                        item.items[columnIndex]
                                                          .subcobertura.opcion
                                                      )
                                                        ? ''
                                                        : 'hidden'
                                                    }}
                                                  >
                                                    <InputIconEditCoberturaMinMax
                                                      loading={
                                                        planLoading &&
                                                        planLoading[
                                                          item.items[
                                                            columnIndex
                                                          ].id_plan
                                                        ]
                                                      }
                                                      onClick={() =>
                                                        onEditPlanCoberturaMinMaxItem(
                                                          item.items[
                                                            columnIndex
                                                          ],
                                                          item.items[
                                                            columnIndex
                                                          ].id,
                                                          columnIndex
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                </>
                                              )}
                                            </Space>
                                          )
                                        }
                                      />
                                    ) : (
                                      !isLanding && (
                                        <Space>
                                          <SelectableListDrawer
                                            isMultiple
                                            url={getLink(
                                              item.items[columnIndex].cobertura
                                                .id,
                                              item.items[columnIndex].cobertura
                                                .id_aseguradora_producto
                                            )}
                                            listChecked={
                                              planes.find(
                                                (e) =>
                                                  e.id ===
                                                  item.items[columnIndex]
                                                    .id_plan
                                              )?.planSubcoberturaOpcion
                                            }
                                            porDefecto={
                                              item.items[columnIndex]
                                                .subcobertura
                                            }
                                            columnsData={
                                              columnsOpcionesCobertura
                                            }
                                            title={
                                              item.items[columnIndex].cobertura
                                                .descripcion
                                            }
                                            textButton="Opciones de cobertura"
                                            placement={
                                              screens && screens.md === false
                                                ? 'bottom'
                                                : 'right'
                                            }
                                            handleChange={(
                                              seleccionadas,
                                              porDefecto
                                            ) => {
                                              onEditPlanSubcoberturas(
                                                seleccionadas,
                                                porDefecto,
                                                item.items[columnIndex].id_plan
                                              );
                                            }}
                                          />
                                        </Space>
                                      )
                                    )}
                                  </>
                                )}
                              </>
                            )}
                            {rowIndex !== 0 && item.plan && (
                              <>
                                {item.franquicia_general &&
                                  (item.sumas[columnIndex] !== 'No Aplica' ? (
                                    <Space>
                                      <span style={{ display: 'flex' }}>
                                        {suma}
                                      </span>
                                      {onEditPlanFranquicia && (
                                        <InputIconEditFranquicia
                                          loading={
                                            planLoading &&
                                            planLoading[
                                              item.plan[columnIndex].id
                                            ]
                                          }
                                          onClick={() =>
                                            onEditPlanFranquicia(
                                              item.plan[columnIndex].id
                                            )
                                          }
                                        />
                                      )}
                                    </Space>
                                  ) : (
                                    'No Aplica'
                                  ))}
                              </>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  )}
                  {sinCoberturas && (
                    <tr key="emptyRow">
                      <td
                        colSpan={item.sumas.length + 1}
                        style={{
                          padding: 16,
                          maxWidth: screens && screens.md === false ? 170 : 500
                        }}
                      >
                        <Typography.Text type="secondary">
                          Sin coberturas
                        </Typography.Text>
                      </td>
                    </tr>
                  )}
                </Fragment>
              ))}
            </tbody>
          </table>
        </div>
        <div className="table-shadow shadow-right" />
      </Container>
    </>
  );
};

export default PlanEditor;
